import { Spacing } from '@persona-id/design-tokens';
import { FC } from 'react';
import { useDragLayer } from 'react-dnd';
import styled from 'styled-components';

import {
  moduleOutlineMixin,
  ModulePreview,
} from 'dashboard/apps/DashboardLayoutEditor/LayoutPreview/layers/shared';
import { GridContainer } from 'dashboard/apps/DashboardLayoutEditor/LayoutPreview/LayoutCanvas';
import { isModuleDragPreviewUseDragLayer } from 'dashboard/dnd/types';
import { Z_INDICES } from 'dashboard/styles/variables';

const ModuleBoundingBox = styled('div')`
  ${moduleOutlineMixin}
  position: fixed;
  z-index: ${Z_INDICES.withShadow};
  padding: ${Spacing[2]};
  outline-style: solid;
  width: 112px;
  height: 112px;
  transform: translate(-50%, -50%);
`;

interface ModuleShadowIndicatorProps {
  totalRows: number;
  canvasClientBoundingRect: DOMRect;
  isDragOverCanvas: boolean;
}

export const ModuleDragPreviewLayer: FC<ModuleShadowIndicatorProps> = ({
  totalRows,
  isDragOverCanvas,
}) => {
  const collectedProps = useDragLayer<GlobalUseDragLayer>((monitor) => ({
    currentClientOffset: monitor.getSourceClientOffset(),
    currentOffset: monitor.getClientOffset(),
    isDragging: monitor.isDragging(),
    itemType: monitor.getItemType(),
  }));

  if (!isModuleDragPreviewUseDragLayer(collectedProps)) return null;

  const { currentOffset } = collectedProps;

  if (!isDragOverCanvas) {
    const moduleStyles = {
      top: `${currentOffset.y}px`,
      left: `${currentOffset.x}px`,
    };

    return (
      <GridContainer rows={totalRows} disablePointerEvents>
        <ModuleBoundingBox style={moduleStyles}>
          <ModulePreview data-test='module-preview' />
        </ModuleBoundingBox>
      </GridContainer>
    );
  } else {
    return null;
  }
};
